module.exports = __webpack_public_path__ + "img/icon-dot.adca70d6.svg";